"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.seperator = exports.link = void 0;

var _util = require("../../../util");

const link = ({
  theme
}) => ({ ...(0, _util.textStyle)(theme, 'meta'),
  transition: 'color 0.2s ease',
  '&:hover': {
    color: (0, _util.color)(theme, 'interactive.primary.hover')
  },
  '&:active': {
    color: (0, _util.color)(theme, 'interactive.primary.active')
  }
});

exports.link = link;

const seperator = ({
  theme
}) => ({
  margin: (0, _util.spacing)(theme, [0, 'xsmall'])
});

exports.seperator = seperator;
//# sourceMappingURL=Breadcrumbs.style.js.map